import { gql } from '@apollo/client';
import NotificationMessageDTO from './fragments/notificationMessageDTO.fragment.notification';

export default gql`
  mutation markNotificationUnread($uuid: String!) @client {
    markNotificationUnread(input: { notificationUUID: $uuid }) {
      ...NotificationMessageDTO
    }
  }
  ${NotificationMessageDTO}
`;
